import React, { Ref } from 'react';
import { translate } from 'translations/translator';
import { MenuItem } from '@mui/material';
import { AppStoreState } from 'types';
import { useSelector, shallowEqual } from 'react-redux';
import { getLicenseIsTrial } from 'state/modules/user/selectors/user-selectors';
const getTranslation = key => translate('lessonPlanner', key);

type Props = {
  openMoveLessonModal: () => void;
  handleAssignLesson: () => void;
  handleRemoveLesson: () => void;
  ref?: Ref<any>;
};

export const LessonPlannerMenu: React.FC<Props> = React.forwardRef(
  ({ openMoveLessonModal, handleRemoveLesson, handleAssignLesson }) => {
    const user = useSelector(({ user }: AppStoreState) => user);
    const isValidTrialUser: boolean = useSelector(getLicenseIsTrial);
    const classrooms: any = useSelector(
      ({ entity }: AppStoreState) => entity.classrooms,
      shallowEqual
    );
    const shouldDisable = user.isAuditor || isValidTrialUser || classrooms.length <= 0;
    return (
      <>
        <MenuItem disabled={shouldDisable} onClick={handleAssignLesson}>
          {getTranslation('assignLesson')}
        </MenuItem>
        <MenuItem disabled={shouldDisable} onClick={openMoveLessonModal}>
          {getTranslation('moveLessonTo')}
        </MenuItem>
        <MenuItem disabled={user.isAuditor || isValidTrialUser} onClick={handleRemoveLesson}>
          {getTranslation('removeLesson')}
        </MenuItem>
      </>
    );
  }
);
